const nf = new Intl.NumberFormat("en-US");
const compact = new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 });

export const fmtNum = (n) => (n == null ? "" : nf.format(n));
export const fmtCompact = (n) => (n == null ? "" : compact.format(n));

export const fmtDate = (iso, lang) =>
  iso ? new Date(iso).toLocaleDateString(lang === "ar" ? "ar-YE" : "en-GB", { year: "numeric", month: "short", day: "numeric" }) : "";

export const intlDigits = (number) => {
  let digits = String(number || "").replace(/\D/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  if (digits.length === 9 && digits.startsWith("7")) digits = `967${digits}`;
  return digits;
};

export const telLink = (number) => `tel:+${intlDigits(number)}`;

export const waLink = (number, text) => `https://wa.me/${intlDigits(number)}?text=${encodeURIComponent(text)}`;

export const areaLabel = (area, units, nm) => {
  const unit = units?.find((u) => u.code === area.unit);
  return `${fmtNum(area.value)} ${unit ? nm(unit) : area.unit}`;
};

export const shrinkImage = (file, maxSide = 2000, quality = 0.85) =>
  new Promise((resolve) => {
    if (!file.type.startsWith("image/") || file.type === "image/gif") return resolve(file);
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
      if (scale === 1 && file.size < 1.5e6) return resolve(file);
      const c = document.createElement("canvas");
      c.width = Math.round(img.width * scale);
      c.height = Math.round(img.height * scale);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      c.toBlob((b) => resolve(b ? new File([b], "photo.jpg", { type: "image/jpeg" }) : file), "image/jpeg", quality);
      URL.revokeObjectURL(img.src);
    };
    img.onerror = () => resolve(file);
    img.src = URL.createObjectURL(file);
  });
